module.exports = __webpack_public_path__ + "img/vim.2d660ee6.png";